import LocationsGrid from "./locations-grid";

export default LocationsGrid;